import styled from "styled-components";

export const QueueInformationContainer = styled.div`
	align-items: center;
	border-radius: 16px;
	box-shadow: 0px 10px 40px rgba(18, 18, 18, 0.1);
	display: flex;
	flex-direction: column;
	height: 592.43px;
	justify-content: center;
	max-width: 1000px;
	padding: 1rem;
	text-align: center;
	width: 100%;

	.queue-information__logo {
		display: none;
		padding: 0.5rem;
		max-height: 60px;
	}

	.queue-information__title {
		font-size: 20px;
		font-weight: 500;
	}

	.queue__rocket-icon {
		width: 220px;
		height: 200px;
	}

	.queue__main-text {
		font-size: 40px;
		font-weight: 700;
		margin: 0;
	}

	.queue__quantity-text {
		font-size: 56.612px;
		font-weight: 500;
	}

	.queue__info-text {
		display: flex;
		font-size: 22.6448px;
		font-weight: 500;
		max-width: 124.55px;
		white-space: wrap;
		margin-left: 0.5rem;
	}

	.queue__infoCards-container {
		display: flex;
		justify-content: space-evenly;
		width: 100%;
	}
	.queue__infoCard-container {
		align-items: center;
		display: flex;
		text-align: left;
	}

	.queue__card-info {
		align-items: center;
		border-radius: 8px;
		box-shadow: 0px 10px 20px -12px rgba(46, 46, 46, 0.15);
		display: flex;
		gap: 1rem;
		padding: 1rem;
		height: 124px;
	}
	.info__card-icon-container {
		align-items: center;
		background-color: ${(props) => props.theme.infoIconBackgroundColor};
		border-radius: 8.4918px;
		display: flex;
		justify-content: center;
		padding-bottom: 0.8rem;
		padding-top: 0.8rem;
		width: 76.43px;
	}

	.info__card-icon {
		color: ${(props) => props.theme.infoIconColor};
		font-size: 38px;
	}

	.info__bottom-text {
		font-size: 16px;
		font-weight: 400;
		color: #121212;
	}

	.info__light-text {
		color: #8c8c8c;
		font-size: 14px;
		font-weight: 400;

		span {
			color: #8c8c8c;
			font-weight: 600;
		}
	}
	.queue__bottom-info {
		margin-top: 2rem;
	}

	.queue__meteorite-icon {
		position: absolute;
	}

	@media (max-width: 768px) {
		background-color: transparent;
		box-shadow: none;
		height: auto;
		margin-top: 2rem;

		.queue-information__logo {
			display: block;
		}

		.queue__infoCards-container {
			flex-direction: column;
		}
		.queue__card-info {
			width: auto;
		}
		.queue__info-text {
			max-width: 100%;
		}
		.queue-information__title {
			font-size: 16px;
		}
		.queue__main-text {
			font-size: 20px;
		}
		.queue__quantity-text {
			font-size: 28px;
		}
		.queue__info-text {
			font-size: 16px;
			margin-left: 0.5rem;
		}
		.queue__card-info {
			height: 68px;
		}
		.info__card-icon-container {
			width: 32px;
		}
		.info__card-icon {
			font-size: 18px;
		}
	}
`;
